import { render, staticRenderFns } from "./ordersListDetailTable.vue?vue&type=template&id=443d8736&scoped=true"
import script from "./ordersListDetailTable.vue?vue&type=script&lang=js"
export * from "./ordersListDetailTable.vue?vue&type=script&lang=js"
import style0 from "./ordersListDetailTable.vue?vue&type=style&index=0&id=443d8736&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443d8736",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('443d8736')) {
      api.createRecord('443d8736', component.options)
    } else {
      api.reload('443d8736', component.options)
    }
    module.hot.accept("./ordersListDetailTable.vue?vue&type=template&id=443d8736&scoped=true", function () {
      api.rerender('443d8736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowOrderManagement/components/ordersListDetailTable.vue"
export default component.exports